// extracted by mini-css-extract-plugin
export default {"container":"styles_container__MDUqI","controlsBar":"styles_controlsBar__jDbfP","resultsBar":"styles_resultsBar__mL42c","tableTitle":"styles_tableTitle__Gn+xW"};